<template>
  <div class="vendor-view-wrap">
    <div
      v-if="list.length === 0"
      class="image-slot">
      <i
        class="el-icon-picture-outline"
        style="font-size:40px;"></i>
    </div>
    <template v-else>
      <div
        v-for="item in list"
        :key="item.vendorId"
        class="vendor-item">
        <div class="vendor-image-wrap">
          <img
            :src="item.coverImage"
            class="vendor-image">
        </div>
        <div class="title">{{ item.vendorShortname }}</div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'WeVendorView',
  props: {
    list: { type: Array, default() { return [] } }
  }
}
</script>
<style lang="stylus" scoped>
.vendor-view-wrap {
  padding: 0 8px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto
  min-height: 100px
}
.vendor-item {
  flex: 0 0 100px;
  width: 0;
}
.vendor-item+.vendor-item {
  margin-left: 8px;
}
.vendor-image-wrap {
  padding-top: 60%
  position relative
  .vendor-image {
    position absolute
    left: 0;
    top: 0
    width: 100%
    height: 100%
    object-fit: cover;
  }
}
.title{
  font-size: 14px;
  padding: 0
}
</style>
